import { DownloadIcon } from '@chakra-ui/icons';
import { Button } from '@chakra-ui/react';
import { useState } from 'react';
import { CSVLink } from 'react-csv';

import { buildRepaymentsPerCohortCsvPayload } from './buildRepaymentsPerCohortCsv';

const RepaymentsPerCohortCsv = ({ modelResults, resolveDownloadFilename }) => {
  const [csvData, setCsvData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [downloadFilename, setDownloadFilename] = useState(
    'repayments-per-cohort.csv'
  );

  const generateCsvData = () => {
    if (resolveDownloadFilename) {
      setDownloadFilename(resolveDownloadFilename('repayments-per-cohort'));
    }

    const payload = buildRepaymentsPerCohortCsvPayload(modelResults);
    if (!payload) {
      setCsvData([]);
      setHeaders([]);
      return;
    }
    setHeaders(payload.headers);
    setCsvData(payload.data);
  };

  return (
    <Button variant={'outline'} leftIcon={<DownloadIcon />}>
      <CSVLink
        data={csvData}
        headers={headers}
        filename={downloadFilename}
        onClick={generateCsvData}
        asyncOnClick={true}
      >
        Repayments per Cohort
      </CSVLink>
    </Button>
  );
};

export default RepaymentsPerCohortCsv;
